import React from 'react';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { BrancheFormField, BrancheFormValue } from '../type';
import { buildDto } from '../utils';

import ModalEdition from './ModalEdition';

interface ModalCreateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalCreate({
  close,
  visible,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: BrancheFormValue = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: BrancheFormValue) =>
      AdminFonctionnelControllerApi.createBrancheUsingPOST(buildDto(values)),
  );
  const { validate } = useValidateReferentielForm(
    (field: BrancheFormField, values: BrancheFormValue) =>
      AdminFonctionnelControllerApi.validateCreateBrancheFieldUsingPOST(
        field,
        buildDto(values),
      ),
    response => response.brancheViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Créer une branche"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
